import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '..';
import { Auth } from 'aws-amplify';
import showNotification from '../../components/Notification';
import axios from 'axios';
import { get } from 'lodash';
import { RootState } from '.';
interface AuthState {
  user: any;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: {},
  isAuthenticated: false,
};

type LoginPayload = {
  user: any;
};

const authSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    loginSuccess(state, action: PayloadAction<LoginPayload>) {
      return { ...state, user: action.payload.user, isAuthenticated: true };
    },
    logout() {
      return initialState;
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;

export const selecCurrentCognitoUser = createSelector(
  (state: RootState) => state.authReducer,
  (authReducer: AuthState) => authReducer.user,
);

export const selectSuperAdminInfo = createSelector(
  (state: RootState) => state.authReducer,
  (authReducer: AuthState) => get(authReducer, 'user.attributes', {}),
);

export const logoutWealthie = (): AppThunk => async (dispatch) => {
  await Auth.signOut();
  dispatch(logout());
};

export const loginWealthie = (
  userName: string,
  password: string,
  history: any,
): AppThunk => async (dispatch) => {
  try {
    const user = await Auth.signIn(userName, password, {
      appId: 'works.wealthie.auth',
    });
    const token = get(user, 'signInUserSession.accessToken.jwtToken', '');
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    dispatch(loginSuccess({ user }));
    history.push('/users');
  } catch (error) {
    showNotification({
      type: 'error',
      message: 'Somethings went wrong, please try again',
    });
  }
};

export default authSlice.reducer;
